import React, { useEffect, useState, useLayoutEffect } from "react";
import styled from "styled-components";
import BaseLayout from "../base/BaseLayout";
import LOGO from "../../assets/images/img-logo.png";
import Banner from "../../assets/images/img-banner.jpeg";
import { useHistory } from "react-router";
import { checkAthenticatedUser } from "utils/auth";

export default function AuthedLayout({ children, allAccess, removeLayoutOnSmall }) {
  useEffect(() => {
    if (!checkAthenticatedUser() && !allAccess) {
      history.push("/login");
    }
  }, []);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const history = useHistory();

  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth < 900) {
        setIsSmallScreen(true);
      } else {
        return setIsSmallScreen(false);
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return (
    <BaseLayout>
      <Wrapper active={removeLayoutOnSmall && isSmallScreen}>
        <div className="container">
          {!(removeLayoutOnSmall && isSmallScreen) && (<div className="logo-container">
            <img src={LOGO} alt="logo" className="logo" onClick={() => {
              history.push("/leads?offset=0&limit=10")
            }} />
          </div>)}
          {children}
        </div>
      </Wrapper>
    </BaseLayout>
  );
}

const Wrapper = styled.div`
  background-image: url(${Banner});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: auto;
  .logo-container {
    margin-bottom: 20px;
  }
  .logo {
    background: none;
    width: 250px;
    margin: 10px;
    cursor: pointer;
  }
  .container {
    padding: ${props => props.active ? '0' : '50px'};
    text-align: center;
    @media (max-width: 500px) {
      padding: ${props => props.active ? '15px 10px' : '50px 10px'};
    }
  }
`;
